import Image from 'next/image';
import { useAtomValue } from 'jotai';
import { FlagIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';

import { PresentationCard, getCountryFlagUrl } from '@restworld/ui-components';
import { Heading, ProgressBar } from '@restworld/ui-ds-base';

import { TabCardWrapper } from '../candidate-profile-section';
import { workerLanguagesAtom } from '../../../../employer-job-listing.atoms';

export const LanguageSection = () => {
  const workerLanguages = useAtomValue(workerLanguagesAtom);
  const { t } = useTranslation('onboarding-page');
  const errorMessage = t('missing_info');

  workerLanguages?.sort((a, b) => {
    const aLevel = a?.language_level_cefr_var?.order;
    const bLevel = b?.language_level_cefr_var?.order;
    return aLevel && bLevel ? bLevel - aLevel : 0;
  });
  return (
    <TabCardWrapper title={t('languages')}>
      <div id="languages" className="flex flex-col items-start pt-4">
        <div className="flex lg:flex-row flex-col lg:gap-12 gap-6 w-full">
          <div className="flex flex-1 flex-col items-start gap-4">
            {workerLanguages?.map((language, index) => {
              const label = (
                <div className="flex flex-row justify-between items-center w-full">
                  <Heading size={5} color="muted" weight="medium">
                    {language?.language_var?.label}
                  </Heading>
                  <Heading size={5} color="muted" weight="normal">
                    {language?.language_level_cefr_var?.label}
                  </Heading>
                </div>
              );
              const level = language?.language_level_cefr_var?.order;
              const percent = level ? (level / 6) * 100 : 0;
              return (
                <PresentationCard
                  key={index}
                  label={label}
                  header={level ? <ProgressBar percent={percent} /> : errorMessage}
                  icon={<CountryFlag countryShortKey={language?.language_var.key as keyof typeof countryShortKeyMap} />}
                  contentStyling={'gap-2'}
                />
              );
            })}
            {!workerLanguages?.length && (
              <Heading size={5} weight="normal" color="muted">
                {errorMessage}
              </Heading>
            )}
          </div>
        </div>
      </div>
    </TabCardWrapper>
  );
};
const CountryFlag = ({ countryShortKey }: { countryShortKey?: keyof typeof countryShortKeyMap }) => {
  const countyImgUrl = countryShortKeyMap[countryShortKey];
  return countyImgUrl ? (
    <Image alt={countryShortKey} src={getCountryFlagUrl(countyImgUrl)} height={24} width={24} />
  ) : (
    <FlagIcon className="w-6 h-6 text-primary-700" />
  );
};
const countryShortKeyMap = {
  russian: 'RU',
  english: 'GB',
  italian: 'IT',
  spanish: 'ES',
  french: 'FR',
  german: 'DE',
};
